import React, { useState, useEffect } from "react";
import Modal from "../../../../components/Dialog/Modal";
import { IoSparklesSharp } from "react-icons/io5";
import GenerativeIaEvaluationService from "../../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService";
import LcLoading from "../../../../components/Generic/LcLoading";
import "./index.css";
import LcIconLink from "../../../../components/Generic/LcIconLink";
import AlertNotification, { AlertColor } from "../../../../components/Dialog/AlertNotification";
import ContentEditable from "react-contenteditable";
import { PPTextField } from "processor-plataform-ui";
import { BiSend } from "react-icons/bi";

interface Props {
    visible: boolean,
    setVisible: Function
    solicitation: any
    user: any
    conclusionText: string
    setReloadSummaryConclusion?: Function
}

const SolicitationConclusionSummary: React.FC<Props> = (props) => {
    const generativeIaEvaluationService = new GenerativeIaEvaluationService(props);
    const [summaryText, setSummaryText] = useState<string>("");
    const [disabled, setDisabled] = useState<boolean>(true);
    const [summary, setSummary] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>("");
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);
    const [additionalPrompt, setAdditionalPrompt] = useState<string>("");
    const [conclusionText, setConclusionText] = useState<string>("");

    useEffect(() => {
        if (props.visible) {
            setNewSummary();
        }
    }, [props.visible]);

    useEffect(() => {
        setConclusionText(props.conclusionText);
    }, [props.conclusionText])

    const getSummary = async () => {
        setLoading(true);

        try {
            const response = await generativeIaEvaluationService.GetGenerativeIaEvaluationList(props.solicitation.id);
            const commentSummary = response.data.filter(x => x.recordType == 2);

            if (commentSummary.length > 0) {
                const textString = JSON.stringify(commentSummary[0].text).replaceAll("\\n", "<br>");
                const _text = JSON.parse(textString);
                setSummaryText(_text);
                setSummary(commentSummary[0]);
                setDisabled(true);
            }
        }
        catch (error) {
            debugger
        }

        setLoading(false);
    }

    const copyToClipbord = () => {
        const textString = JSON
            .stringify(summaryText)
            .replaceAll("<br>", "\\n")
            .replaceAll("<br />", "\\n")
            .replaceAll("<br/>", "\\n");;
        const _text = JSON.parse(textString);
        navigator.clipboard.writeText(_text);

        setMessage(`Texto copiado com sucesso`);
        setSeverity("success");
        setOpenNotificacao(true);
        setTimeout(() => setOpenNotificacao(false), 2000);
    };

    const handleDisable = () => {
        setDisabled(!disabled);
        const textString = JSON.stringify(summary.text).replaceAll("\\n", "<br>");
        const _text = JSON.parse(textString);
        setSummaryText(_text);
    }

    const saveNewSummary = async () => {
        setLoading(true);

        try {
            const _summary = {
                ...summary,
                idSolicitation: props.solicitation.id,
                prompt: summaryText,
                idUser: props.user.id,
                nameUser: props.user.name,
                recordType: 2
            }

            await generativeIaEvaluationService.SetNewCommentSumary(_summary);
            props.setVisible(false);
            props.setReloadSummaryConclusion && props.setReloadSummaryConclusion(true);
            // await getSummary();
        }
        catch (error) {
            debugger
        }

        setLoading(false);
    }

    const setNewSummary = async () => {
        setLoading(true);

        try {
            const solicitationSumarizeRequest = {
                idSolicitation: props.solicitation.id,
                idUser: props.user.id,
                recordType: 2,
                conclusionText: conclusionText
            }

            const response = await generativeIaEvaluationService.SetCommentSummary(solicitationSumarizeRequest);

            if (response.data.responseOpenAI.choices[0].message.content) {
                const content = response.data.responseOpenAI.choices[0].message.content;
                const textString = JSON.stringify(content).replaceAll("\\n", "<br>");
                const _text = JSON.parse(textString);
                setSummaryText(_text);
            }

            // await getSummary();
        }
        catch (error) {
            debugger
        }

        setLoading(false);
    }

    const SetEditCommentSummary = async () => {
        setLoading(true);

        if (additionalPrompt == "") {
            setLoading(false);
            setMessage(`Digite uma mensagem para enviar`);
            setSeverity("error");
            setOpenNotificacao(true);
            setTimeout(() => setOpenNotificacao(false), 2000);
            return;
        }

        try {
            const solicitationSumarizeRequest = {
                idSolicitation: props.solicitation.id,
                idUser: props.user.id,
                recordType: 2,
                additionalPrompt: additionalPrompt,
                prompt: summaryText
            }

            const response = await generativeIaEvaluationService.SetEditCommentSummary(solicitationSumarizeRequest);

            if (response.data.responseOpenAI.choices[0].message.content) {
                const content = response.data.responseOpenAI.choices[0].message.content;
                const textString = JSON.stringify(content).replaceAll("\\n", "<br>");
                const _text = JSON.parse(textString);
                setSummaryText(_text);
            }

            // await getSummary();
        }
        catch (error) {
            debugger
        }

        setAdditionalPrompt("");
        setLoading(false);
    }

    return (
        <Modal
            visible={props.visible}
            title={
                <span style={{ fontSize: "18px", fontWeight: "500" }}>
                    <IoSparklesSharp />
                    <span style={{ paddingLeft: "10px" }}>Sumarização</span>
                </span>
            }
            close={() => props.setVisible(false)}
            width={"auto"}
        >
            <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={() => setOpenNotificacao(false)} />

            <div className={"SolicitationConclusionSummary"}>
                <div className={"all"}>
                    <div className={"content"}>
                        <div className={"body"}>
                            <LcLoading label={"Carregando..."} loading={loading} height={"150px"} width={"450px"}>
                                {
                                    disabled
                                        ? <div
                                            id={"AiText"}
                                            className={`AiText ${disabled ? "disabled" : ""}`}
                                            dangerouslySetInnerHTML={{ __html: summaryText }}
                                            style={{ width: "900px" }}
                                        />
                                        : <ContentEditable
                                            html={summaryText}
                                            className={"AiText"}
                                            id={"AiText"}
                                            style={{ width: "900px" }}
                                            onChange={(e) => {
                                                var textString = JSON.stringify(e.target.value).replaceAll("\\n", "<br>");
                                                var _text = JSON.parse(textString);
                                                setSummaryText(_text)
                                            }}
                                        />
                                }

                                {
                                    <>
                                        {
                                            !loading &&
                                            <div style={{
                                                display: "flex",
                                                justifyContent: (summaryText != "") ? "space-between" : "flex-end",
                                                alignItems: "center",
                                                margin: "10px",
                                                height: "40px"
                                            }}>
                                                <div className={"btn-wrapper"}>
                                                    <LcIconLink
                                                        icon={"ppi ppi-clipboard"}
                                                        size={"small"}
                                                        tooltip={"Copiar"}
                                                        onClick={() => copyToClipbord()}
                                                    />
                                                    <LcIconLink
                                                        icon={"ppi ppi-refresh"}
                                                        size={"small"}
                                                        tooltip={"Gerar sumário novamente"}
                                                        onClick={() => setNewSummary()}
                                                        disabled={!disabled}
                                                    />
                                                    <LcIconLink
                                                        icon={"ppi ppi-pencil-alt"}
                                                        size={"small"}
                                                        tooltip={"Editar"}
                                                        activedAfterClick={!disabled}
                                                        onClick={() => handleDisable()}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </>
                                }

                                {
                                    disabled &&
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-end"
                                        }}>
                                        <PPTextField
                                            placeholder={"Digite uma mensagem..."}
                                            style={{
                                                width: "900px",
                                                fontSize: "13.333333px"
                                            }}
                                            onChange={(e) => setAdditionalPrompt(e.target.value)}
                                            value={additionalPrompt}
                                            autoComplete={"new-password"}
                                        />

                                        <div
                                            className={"lciconlink"}
                                            style={{
                                                position: "fixed",
                                                margin: "10px 10px 0px 0px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => SetEditCommentSummary()}
                                        >
                                            <BiSend size={"20px"} color={"#555454"} />
                                        </div>

                                        <div style={{ display: "flex", margin: "20px 0 10px 0" }}>
                                            <button className={"lc-button bg-info ia-button"} style={{ marginRight: "15px" }} onClick={() => saveNewSummary()}>Salvar</button>
                                            <button className={"lc-button bg-info ia-button"} onClick={() => props.setVisible(false)}>Cancelar</button>
                                        </div>
                                    </div>
                                }
                            </LcLoading>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default SolicitationConclusionSummary;